<template lang="pug">
.tab.flex_v(:class="{ selected: selected }")
  img(:src="img")
  h5.i_mt_1.i_md_2.i_mt_sm_1 {{ title }}
</template>

<script>
import MediaImg from "@/components/common/MediaImg";

export default {
  name: "Tab",
  components: {
    "media-img": MediaImg,
  },
  props: {
    title: String,
    img: String,
    selected: Boolean,
  },
  data() {
    return {
      // selected: Boolean,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/tab";
</style>
